import {toBaseScalarPricingPayload} from "@/features/pricing";
import {UpdateSessionData} from "../../../../features/sessions";
import {EditSessionFormValues} from "../types";

/**
 * Converts form values to UpdateSessionData for the useUpdateSession hook.
 * Maps form field names to domain camelCase convention.
 */
export function editSessionDto(values: EditSessionFormValues): UpdateSessionData {
  const redirectType =
    values.redirectAfterPurchase === "custom-url"
      ? "url"
      : values.redirectAfterPurchase ?? "none";

  const coverImageUrl =
    values.cover_images && values.cover_images.length > 0
      ? values.cover_images[0].media_url
      : values.coverImage || null;
  const redirectFields: Partial<
    Pick<UpdateSessionData, "redirectType" | "urlRedirect" | "telegramGroupChatId">
  > =
    redirectType === "url"
      ? {redirectType, urlRedirect: values.url_redirect, telegramGroupChatId: null}
      : redirectType === "telegram"
      ? {
          redirectType,
          urlRedirect: null,
          telegramGroupChatId: values.telegramGroupId ?? null,
        }
      : {};

  return {
    id: values.id,
    name: values.name,
    description: values.description,
    slug: values.slug,
    callDuration:
      values.callDuration === "-1"
        ? Number(values.customCallDuration)
        : Number(values.callDuration),
    // Keep the rebrand-V2 pricing model mapping introduced by the pulled branch.
    // It supplies the base price/currency, currencies and Pay What You Want fields.
    ...toBaseScalarPricingPayload(values),
    ...redirectFields,
    audioLocation: values.callLocation === "phone",
    videoLocation: ["video", "google_meet", "zoom"].includes(
      values.callLocation as string
    ),
    hasGoogleMeet: (values.callLocation as string) === "google_meet",
    videoPlatform: values.callLocation === "zoom" ? "zoom" : undefined,
    hideServiceFromMenu: values.hideFromProfile,
    requestPhoneNumber: values.requestCustomerPhoneNumber,
    coverImage: coverImageUrl,
    bookingQuestions:
      values.bookingQuestions.length > 0
        ? values.bookingQuestions.map((q) => {
            if (
              q.answerType === "checkbox" ||
              q.answerType === "dropdown" ||
              q.answerType === "radio-button"
            ) {
              return {
                question: q.question,
                required: q.required,
                answerType: q.answerType,
                options: q.options.map((o) => o.optionLabel),
              };
            } else {
              return {
                question: q.question,
                required: q.required,
                answerType: q.answerType,
              };
            }
          })
        : [],
    availabilityScheduleId: values.availabilityScheduleId,
    enableCurrencyConversion: values.callPriceType !== "free",
    selectedCurrencies:
      values.callPriceType === "free" ? [] : values.selected_currencies || [],
  };
}
